import _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";
import type { Flag } from "@/models/flag";
import type Light from "@/models/light/light";

interface Filter {
    filteredItems: Flag[] | Record<string, Light>;
    filterType?: string;
    filteredMarkers?: { uniqueId: string }[];
}

interface SelectMatchesAction {
    payload: Filter;
}

/**
 * Selects lights on the map that match the given filter criteria.
 *
 * @param {SelectMatchesAction} action - The action containing the filter criteria for selecting matches.
 * @yields Selects filter criteria and dispatches light selection updates.
 */
function* selectMatches({ payload: filter }: SelectMatchesAction) {
    try {
        const filteredFlags = filter.filteredItems as Flag[];

        let lights = yield select(({ map }) =>
            _.filter(map.values.global.present.lights, (light) =>
                _.some(filteredFlags, (filteredFlag: Flag) => {
                    if (typeof filteredFlag.value === "function") {
                        return filteredFlag.value([light]);
                    }

                    return _.some(
                        light.flags,
                        (selectedFlag) =>
                            selectedFlag.value === filteredFlag.value,
                    );
                }),
            ),
        );

        if (filter.filterType === "search") {
            lights = _.values(filter.filteredItems);
        }

        yield put(actions.map.general.changeMode("select", { type: "Manual" }));
        yield put(actions.map.general.selectLights(lights, "multi"));

        if (filter.filteredMarkers?.length > 0) {
            yield put(
                actions.map.general.selectMarkers(
                    filter.filteredMarkers.map((m) => m.uniqueId),
                ),
            );
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on selecting matches:", err);
    }
}

export default selectMatches;
